/**
 * @generated SignedSource<<99e76711ffe223154c210edaf75be54a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchResultListArticleSearchQuery$data = {
  readonly articleSearchV2: {
    readonly connection: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ArticleSearchResultItem";
        };
      }>;
      readonly totalCount: number;
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleSearchResultListQuery">;
  readonly " $fragmentType": "searchResultListArticleSearchQuery";
};
export type searchResultListArticleSearchQuery$key = {
  readonly " $data"?: searchResultListArticleSearchQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultListArticleSearchQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "articleTypeIds"
    },
    {
      "kind": "RootArgument",
      "name": "contentTypes"
    },
    {
      "kind": "RootArgument",
      "name": "endDate"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "orderBy"
    },
    {
      "kind": "RootArgument",
      "name": "paywallTypeIds"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "sectionIds"
    },
    {
      "kind": "RootArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "searchResultListArticleSearchQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "articleTypes",
              "variableName": "articleTypeIds"
            },
            {
              "kind": "Variable",
              "name": "contentTypes",
              "variableName": "contentTypes"
            },
            {
              "kind": "Variable",
              "name": "endDate",
              "variableName": "endDate"
            },
            {
              "kind": "Variable",
              "name": "paywallTypeIds",
              "variableName": "paywallTypeIds"
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            },
            {
              "kind": "Variable",
              "name": "sectionIds",
              "variableName": "sectionIds"
            },
            {
              "kind": "Variable",
              "name": "startDate",
              "variableName": "startDate"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "ArticleSearchResult",
      "kind": "LinkedField",
      "name": "articleSearchV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleSearchConnection",
          "kind": "LinkedField",
          "name": "connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleSearchEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArticleSearchResultItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSearchResultListQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b05dd17fa1ff17d5ab7f29b834763aff";

export default node;
